
const AMBASSADOR_APP = 'https://skinteam.herokuapp.com';


function replaceString(string, from, to) {
  return string.split(from).join(to);
}

/*
 * Flow by WeTheme (http://www.wetheme.com)
 * Theme
 */

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

$(document).ready(function(){

  if ($('[href="#cookie-preferences"]').length == 0) {
    $('<li><a href="#cookie-preferences">Cookie Preferences</a></li>').appendTo($('ul.footer-content'));
  }
  $('[href="#cookie-preferences"]').click(function(e) {
    e.preventDefault();
    Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  });
  
  //console.log('Slider ✅')
$('.product-slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight: true,
  lazyLoad: 'ondemand',
  prevArrow: '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 10L13 19L14.4 17.5L7 10L14.4 2.5L13 1L4 10Z" fill="black"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99998 1L5.59998 2.5L13 10L5.59998 17.5L6.99998 19L16 10L6.99998 1Z" fill="black"/></svg></button>',
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});


/*============================================================================
  Index page
==============================================================================*/
theme.indexPage = {
  init: function() {
    this.selectors = {
      featuredProducts: '.homepage-featured-products',
      featuredCollections: '.homepage-collections-slider .collection-grid'
    }

    if ($(this.selectors.featuredProducts).length > 0) {
      //this.buildCarousel($(this.selectors.featuredProducts));
    }

    if ($(this.selectors.featuredCollections).length > 0) {
      this.buildCarousel($(this.selectors.featuredCollections));
    }
  },
  buildCarousel: function($el) {
    $el.owlCarousel({
      margin: 20,
      dots: false,
      nav: true,
      navText: ['<i class="fa fa-2x fa-angle-left"></i>', '<i class="fa fa-2x fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        320: {
          items: 1
        },
         481: {
          items: 2
        },
        992: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  }
}

/*============================================================================
  Bazaarvoice
==============================================================================*/
theme.bazaarvoiceEvents = {
  /*
   * Emit conversion events
   * data: { $type, $label, $value }
   */
  emitConversionEvent: function(data) {
    window.bvCallback = function (BV) {
      window.BV = BV;
      BV.pixel.trackConversion(data);
    };

    if (window.BV && window.BV.pixel) {
      BV.pixel.trackConversion(data);
    }
  },

  /*
   * Emit transactional events
   * data: { $currenty, $orderId, $total, $items, $optional_order_parameter, $optional_PII_parameter }
   */
  emitTransactionEvent: function(data) {
    window.bvCallback = function (BV) {
      BV.pixel.trackTransaction(data);
    };
  }
}

/*============================================================================
  Product page
==============================================================================*/
theme.productPage = {
  init: function() {
    this.selectors = {
      productImages: '.product-thumbnails'
    }

    let eventData = {
      type: 'visit_product',
      value: window.location.origin+window.location.pathname,
      label: 'Visit product'
    }
    theme.bazaarvoiceEvents.emitConversionEvent(eventData);
    var productImageOptions = {
      margin: 10,
      navText: ['<i class="fa fa-2x fa-angle-left"></i>', '<i class="fa fa-2x fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1,
          dots: true,
          nav: false
        },
        770: {
          items: 2,
          dots: false,
          nav: true
        },
        1200: {
          items: 4,
          dots: false,
          nav: true
        }
      },
      onTranslate: function() {
        $('.owl-item').find('video').each(function() {
            this.pause();
        });
      },
      onResized: function(){
            let width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

        if (width > 768) {
          $('.owl-item').find('video').each(function() {
            location.reload();
        });
        }
      }
    };

    var slider = $(this.selectors.productImages).owlCarousel(productImageOptions);

    // owl carousel on changed, check video 
    // TODO: autoplay video when video slide is active, pause when going to next slide, toggle play if video exists
    //  $(this.selectors.productImages).on("refreshed.owl.carousel changed.owl.carousel", function (
    //    property
    //  ) {
    //    let width =
    //      window.innerWidth ||
    //      document.documentElement.clientWidth ||
    //      document.body.clientWidth;

    //    if (width < 768) {
    //      let current = property.item.index;
    //      let $thumbnail = $(property.target).find(".owl-item").eq(current).find(".product-single__thumbnail-wrapper")
    //      let thumbClass = $thumbnail.attr('class');
    //      let isVideo = thumbClass.includes(
    //        "product__video-thumb"
    //      );
    //    if(isVideo){

    //       const videoWrapper = getVideoAttributesFromThumbData($thumbnail);
    //       $thumbnail.html(videoWrapper);

    //       $thumbnail.find("video").get(0).play();
    //     }

    //   } 
    // });
    

    // function getVideoAttributesFromThumbData($thumbnail) {
    //   var $videoAttributes = $thumbnail.find(".video-attributes");
    //   var poster = $videoAttributes.attr("data-poster");
    //   var mp4Attributes = {
    //     class: "product__video",
    //     playsinline: true,
    //     loop: true,
    //     muted: true,
    //     poster,
    //   };
    //   var videoElement = $("<video/>").attr(mp4Attributes);
    //   var xmpegSrc = $videoAttributes.attr("data-video-src");
    //   var xmpegType = $videoAttributes.attr("data-video-type");
    //   var xmpegSourceAttributes = {
    //     src: xmpegSrc,
    //     type: xmpegType,
    //   };
    //   var xmpegSource = $("<source/>").attr(xmpegSourceAttributes);

    //   var mp4src = $videoAttributes.attr("data-video-mp4-src");
    //   var mp4type = $videoAttributes.attr("data-video-mp4-type");
    //   var mp4SourceAttributes = {
    //     src: mp4src,
    //     type: mp4type,
    //   };
    //   var mp4Source = $("<source/>").attr(mp4SourceAttributes);

    //   videoElement.append(xmpegSource, mp4Source);
    //   var videoWrapper = $(
    //     "<div class='product-single__photo product-single__video'/>"
    //   ).append(videoElement);

    //   return videoWrapper;
    // }

    // If user scrolled on load (e.g. hit back button)
    var $bottomMenu = $('.productBottomMenu');
    // if (window.scrollY > 0 && $bottomMenu.length > 0) {
      $bottomMenu.addClass('sticky');
      $('body').addClass('stickyCro');
    // }

    $(document).on('click', '#BottomAddToCart', this.onBottomAddToCart.bind(this));
    $(window).on('scroll', this.onScroll.bind(this));
  },
  onBottomAddToCart: function() {
    var $form = $('#AddToCartForm');
    if ($form.length > 0) {
      $form.trigger('submit');
    }
  },
  onScroll: function() {
    // var $bottomMenu = $('.productBottomMenu');
    // if (window.scrollY > 5) {
    //   $bottomMenu.addClass('sticky');
    //   $('body').addClass('stickyCro');
    // }
    // else {
    //   $bottomMenu.removeClass('sticky');
    //   $('body').removeClass('stickyCro');
    // }
  }
}

/*============================================================================
  Product page
==============================================================================*/
theme.bundleProductPage = {
  init: function() {
    this.selectors = {
      bundleFormOnCollection: ".BundleAddToCartForm",
      bundleAddToCartForm: "#BundleAddToCart"
    }

    $(document).on('submit', this.selectors.bundleAddToCartForm, this.handleSubmit.bind(this));
    $(document).on('submit', this.selectors.bundleFormOnCollection, this.handleSubmitBundle.bind(this));
  },
  handleSubmit: function(e) {
    e.preventDefault();
    let $bundleAddToCartForm = $(this.selectors.bundleAddToCartForm);
    let parent = $bundleAddToCartForm.data('parent');

    let variant_ids = $bundleAddToCartForm.find('.variant').map(function(i,v){
      return $(v).val();
    }).get();

    ShopifyAPI.addBundleItems(variant_ids, parent);
  },
  handleSubmitBundle: function(e) {
    e.preventDefault();
    let $bundleAddToCartForm = $(e.target);
    let parent = $bundleAddToCartForm.data('parent');

    let variant_ids = $bundleAddToCartForm.find('.variant').map(function(i,v){
      return $(v).val();
    }).get();

    ShopifyAPI.addBundleItems(variant_ids, parent);
  }
}

/*============================================================================
  Contact us page
==============================================================================*/
theme.contactPage = {
  init: function() {
    this.selectors = {
      form: '#contact_form'
    }

    $(document).on('submit', this.selectors.form, this.emitEvent.bind(this))
  },
  emitEvent: function(e) {
    $form = $(this.selectors.form);
    let eventData = {
      type: 'contact_us',
      value: $form.serialize(),
      label: 'Contact US'
    }
    theme.bazaarvoiceEvents.emitConversionEvent(eventData)
  }
}

/*============================================================================
  Sampling at Checkout
==============================================================================*/
theme.samplingCheckout = {
  init: function() {
    this.selectors = {
      container: '.ajaxcart__samples-wrapper',
      headerBtn: '.js-samples-header',
      hideBtn: '.js-hide-sampling',
      cancelBtn: '.js-cancel-sampling',
      addToBag: '.js-add-to-bag',
      removeFromBag: '.js-remove-from-bag'
    }

    this.is_multiple = "false" == "true";
    this.promo_code = "";
    this.line_items = [];

    let self = this;

    if ($('.template-cart').length > 0) {
      ShopifyAPI.getCart(function(cart) {
        self.initSampling(null, cart);
      });
    }

    //$(document).on('afterCartLoad.ajaxCart', this.initSampling.bind(this));
    $(document).on('afterCartLoad.ajaxCart', this.initFreebie.bind(this));
    $(document).on('click', this.selectors.headerBtn, this.toggleSamplesBlock.bind(this));
    $(document).on('click', this.selectors.hideBtn, this.toggleSamplesBlock.bind(this));
    $(document).on('click', this.selectors.cancelBtn, this.toggleSamplesBlock.bind(this));
    $(document).on('click', this.selectors.addToBag, this.handleAddToBag.bind(this));
    $(document).on('click', this.selectors.removeFromBag, this.handleRemoveFromBag.bind(this));
  },
  initSampling: function(e, cart) {
    this.line_items = cart.items;

    $('.ajaxcart__samples-wrapper .slider_wrap').owlCarousel({
      margin: 20,
      dots: false,
      nav: true,
      navText: ['<i class="fa fa-2x fa-angle-left"></i>', '<i class="fa fa-2x fa-angle-right"></i>'],
      responsive: {
        0:{
          items:1
        },
        1200: {
          items: 3
        }
      }
    });

    if (!this.checkPassThreashold(cart)) {
      // Disable select a sample
    }

    $container = $(this.selectors.container);
    $container.find('.ajaxcart__samples-header').removeClass('invisible');
    $container.find('.ajaxcart__samples-inner').addClass('invisible');

    this.updateSamples(cart);
  },
  initFreebie: function(e, cart) {
      var freebieVariant = gwp_threshold_variant_id;
      var line_item_key = 0;
      var has_freebie = false;
      $.each(cart.items, function(i, cartItem) {
        if (cartItem.id == freebieVariant && cartItem.properties.type == "gwp") {
          has_freebie = true;
          line_item_key = cartItem.key;
        }
      });
      
      if (cart.total_price >= gwp_threshold && freebieVariant > 0 && enable_gwp_threshold) {
        if (!has_freebie) {
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data:  {
                id: freebieVariant,
                quantity: 1,
                properties: {
                  gwp: true,
                  type: "gwp",
                }
              },
              success: function(res){
                ajaxCart.load();
              },
              error: function(){
                // Fail silently
              }
            });
          }
      } else {
        if (has_freebie) {
          // Remove product
          if (line_item_key != 0) {
            jQuery.post('/cart/update.js', "updates[" + line_item_key + "]=0", function(data) {
              ajaxCart.load();
            }, "json");
          }
          
        }
      }
    
  },
  toggleSamplesBlock: function(e) {
    e.preventDefault();
    $container = $(this.selectors.container);
    $container.find('.ajaxcart__samples-header').toggleClass('invisible');
    $container.find('.ajaxcart__samples-inner').toggleClass('invisible');
    setTimeout(() => {
      var $currentHeight = $('.ajaxcart__samples-inner')[0].scrollHeight;
      $('.ajaxcart .ajaxcart__inner').animate({ scrollTop: $currentHeight }); 
      
    }, 0);
  },
  handleAddToBag: function(e) {
    var isCartPage = $('.template-cart').length > 0;

    e.preventDefault();
    let $target = $(e.target);
    let selected_product = $target.parents('.sample-product, .upsell-product');

    let variantId = selected_product.data('id').toString();
    if (isCartPage) {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: 'id='+ variantId + '&quantity=1',
        success: function(res){
          location.reload();
        },
        error: function(){
        }
      });
    }
    else {
      var samples = $('.ajaxcart__samples');
      samples.find('.add-to-bag').attr('disabled', true);
      ShopifyAPI.addAllItems(variantId);
    }
  },
  handleRemoveFromBag: function(e) {
    e.preventDefault();

    var isCartPage = $('.template-cart').length > 0;

    let self = this;
    let $target = $(e.target);
    let selected_product = $target.parents('.sample-product');

    let variantId = selected_product.data('id');
    if (isCartPage) {
      if ($('.cart__remove[data-id='+variantId+']').length > 0) {
        $('.cart__remove[data-id='+variantId+']')[0].click();
      }
    }
    else {
      var samples = $('.ajaxcart__samples');
      samples.find('.remove-from-bag').attr('disabled', true);
      ShopifyAPI.changeItemById(variantId, 0, function(cart) {
        ajaxCart.buildCart(cart);
      });
    }
  },
  updateSamples: function(cart) {
    let self = this;
    let $container = $(this.selectors.container);
    let sample_products = $container.find('.sample-product');

    var sample_ids = sample_products.map(function() {
      return $(this).data('id');
    }).get().filter(function(value, index, self) {
      return self.indexOf(value) == index
    });

    selected_ids = []

    if (cart) {
      $('.ajaxcart__samples-wrapper').show();
      cart.items.forEach(function(item) {
        if (sample_ids.includes(item.id)) {
          selected_ids.push(item.id)
          $('.sample-product-'+item.id).addClass('selected');
          $('.sample-product-'+item.id).find('.add-to-bag').removeClass('disabled');
          $('.sample-product-'+item.id).find('.add-to-bag').attr('disabled', false);
          $('.ajaxcart__samples-wrapper').hide();
        }
      });
    }

    if (selected_ids.length == 0) {
      $('.sample-product').removeClass('selected');
      $('.sample-product').find('.add-to-bag').removeClass('disabled');
      $('.sample-product').find('.add-to-bag').attr('disabled', false);
    }
    else {
      sample_ids.forEach(function(id) {
        if (!selected_ids.includes(id)) {
          $('.sample-product-'+id).removeClass('selected');
          if (!self.is_multiple) {
            $('.sample-product-'+id).find('.add-to-bag').addClass('disabled');
            $('.sample-product-'+id).find('.add-to-bag').attr('disabled', true);
          }
        }
      })
    }
  },
  checkPassThreashold: function(cart) {
    return cart.item_count > 0;
  }
}

/*============================================================================
  Cart upsell products
==============================================================================*/
theme.cartUpsellProducts = {
  init: function() {
    this.selectors = {
      original: '.cart-upsell-products-original',
      samples: '#CartDrawer .ajaxcart__samples-wrapper',
    }

    $(document).on('afterCartLoad.ajaxCart', this.initCarousel.bind(this));
  },
  initCarousel: function() {
    var $samples = $(this.selectors.samples);
    if (!$samples) return;

    var $cartUpsellProducts = $(this.selectors.original).clone();
    $cartUpsellProducts.removeClass('hidden');
    $cartUpsellProducts.removeClass('.cart-upsell-products-original');

    $cartUpsellProducts.insertBefore($samples);

    $cartUpsellProducts.find('.owl-carousel').owlCarousel({
      margin: 15,
      dots: false,
      nav: true,
      navText: ['<i class="fa fa-2x fa-angle-left"></i>', '<i class="fa fa-2x fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 2
        },
        1200: {
          items: 3
        }
      }
    });
  }
}

/*============================================================================
  Cart Page
==============================================================================*/
theme.cartPage = {
  init: function() {
    this.selectors = {
      removeBundle: '.bundle__item--remove'
    }

    $(document).on('click', this.selectors.removeBundle, this.removeBundleItem);
  },
  removeBundleItem: function() {
    let is_cartpage = $('.template-cart').length;
    let $this = $(this);
    let $row = $(this).parents('.ajaxcart__row');
    let variant_ids = $this.data('variants');

    if (variant_ids) {
      $row.addClass('is-loading');
      variant_ids = variant_ids.split(',');
      ShopifyAPI.removeBundleItems(variant_ids, is_cartpage);
    }
  }
}  

/*============================================================================
  Account
==============================================================================*/
theme.account = {
  init: function() {
    this.selectors = {
      editAddress: '.js-account-actions'
    }
    $(document).on('click', this.selectors.editAddress, this.toggleAddress).bind(this);
    $(document).on('click', '.js-open-ambassador', this.openAmbassadorApp.bind(this));
  },
  openAmbassadorApp: function() {
    let time = new Date();
    let token = window.btoa(time.getTime()+':'+window.customer_id);
    let url = AMBASSADOR_APP + '/autologin?token=' + token;
    var win = window.open(url, '_blank');
    win.focus();
  },
  toggleAddress: function(){
    var account_items = $('.js-account-info');
    var kca_embed = $('#kca-embed');
    account_items.toggle();
    kca_embed.toggle();
   $(this).text($(this).text() == 'Edit' ? 'Done' : 'Edit');
  }
}

/*============================================================================
  Account Subscription
==============================================================================*/
theme.accountSubscription = {
  init: function() {
    this.moneyFormat = '${'+'{amount}}';
    this.storeCustomerId = $('.account-wrapper').data('customer-id');
    this.serverUrl = 'http://hrs-media.com/versedskin';
    this.rechargeCustomer = {};
    this.paymentSources = [];
    this.subscriptions = [];
    this.getRechargeCustomer();
    this.getSubscriptions();

    this.selectors = {
      subscriptionTable: '.recharge-subscriptions',
      subscriptionEdit: '.subscription-edit'
    }

    $(document).on('click', '.rc-toggler-button', function() {
      $formBlock = $(this).parents('.rc-form-block');
      $rcFormContent = $formBlock.find('.rc-form-content');
      $rcFormContent.toggleClass('hide');
    });
  },

  getRechargeCustomer: function() {
    let self = this;
    this.callAPI('POST', 'recharge_customer.php', { store_customer_id: this.storeCustomerId }, function(res) {
      if (res.error) {
        console.log(res.error);
      }
      else {
        self.rechargeCustomer = res;
        self.getBillingInformation();
      }
    });
  },

  getBillingInformation: function() {
    let self = this;
    if (this.rechargeCustomer.id) {
      this.callAPI('POST', 'recharge_payment_sources.php', { customer_id: this.rechargeCustomer.id }, function(res) {
        if (res.error) {
          console.log(res.error);
        }
        else {
          self.paymentSources = res;
          self.updateBillingsView();
        }
      });
    }
  },

  getSubscriptions: function() {
    let self = this;
    this.callAPI('POST', 'recharge_subscriptions.php', { store_customer_id: this.storeCustomerId }, function(res) {
      if (res.error) {
        console.log(res.error);
      }
      else {
        self.subscriptions = res;
      }

      let subscription = {},count=0;
      for (var i = 0; i < self.subscriptions.length; i++) {
        subscription = self.subscriptions[i];
        self.getProduct(subscription.recharge_product_id, function(err, product) {
          count++;
          if (err) { console.log(err); }
          else { subscription.product = product; }
          if (count == self.subscriptions.length) {
            self.updateSubscriptionsView();
          }
        });
      }
    });
  },

  getProduct: function(id, callback) {
    let self = this;
    this.callAPI('POST', 'recharge_product.php', { product_id: id }, function(recharge_product) {
      if (recharge_product.error) {
        callback(recharge_product.error);
      }
      else {
        jQuery.getJSON("/products/"+recharge_product.handle.js, function(product) {
          var _product = JSON.parse(JSON.stringify(recharge_product));
          _product.body_html = product.body_html;
          _product.vendor = product.vendor;
          _product.product_type = product.type;
          _product.tags = product.tags;
          _product.variants = product.variants;
          _product.options = product.options;
          callback(null, _product);
        } );
      }
    });
  },

  updateBillingsView: function() {
    let $accountPaymentSources = $('.account-payment-sources');
    if (this.paymentSources.length > 0) {
      let $render = "",payment_source;
      for (var i = 0; i < this.paymentSources.length; i++) {
        payment_source = this.paymentSources[i];
        $render += 
          '<div class="payment-source">'+
            '<div class="account-info-items-wrapper flex">'+
              '<div class="account-info-items">'+
                '<div class="account-info-item">'+
                  '<label>Card on file</label>'+
                  '<div>'+
                    '<p>'+payment_source.card_brand+' ending in '+payment_source.card_last4+'</p>'+
                    '<p>expires '+payment_source.card_exp_month+'/'+payment_source.card_exp_year+'</p>'+
                  '</div>'+
                '</div>'+
              '</div>'+
              '<div class="account-info-items">'+
                '<div class="account-info-item">'+
                  '<label>Billing information</label>'+
                  '<p>'+
                    payment_source.billing_address.first_name+' '+payment_source.billing_address.last_name+'<br />'+
                    payment_source.billing_address.address1+' '+payment_source.billing_address.address2+'<br />'+
                    payment_source.billing_address.city+' '+payment_source.billing_address.province+' '+payment_source.billing_address.zip+'<br/>'+
                    payment_source.billing_address.country+
                  '</p>'+
                '</div>'+
              '</div>'+
            '</div>'+
          '</div>';
      }
      $accountPaymentSources.html($render);
    }
  },

  updateSubscriptionsView: function() {
    let $subscriptions = $(this.selectors.subscriptionTable);
    if (this.subscriptions.length > 0) {
      let subscription, product_title, next_charge_on="", next_charge_on_date;
      for (var i = 0; i < this.subscriptions.length; i++) {
        subscription = this.subscriptions[i];
        product_title = subscription.product ? subscription.product.title+' '+subscription.product.product_type : subscription.product_title;
        next_charge_on = moment(subscription.next_charge_scheduled_at).format('MMMM DD, YYYY');
        next_charge_on_date = moment(subscription.next_charge_scheduled_at).format('YYYY-MM-DD');

        // Subscription layout
        let $rechargeSubscription = $('<div>', { class: 'recharge-subscription' });
        let $subscriptionInformation = $('<div>', { class: 'subscription-information' });
        let $subscriptionForm = $('<div>', { class: 'subscription-form' });

        $rechargeSubscription.append($subscriptionInformation);
        $rechargeSubscription.append($subscriptionForm);
        
        // Subscription Information
        let $subscriptionInformationContent = 
          '<div class="subscription-header"><span class="subscription-index">Subscription '+(i+1)+'</span> Every '+subscription.charge_interval_frequency+' '+subscription.order_interval_unit+(Number(subscription.charge_interval_frequency) > 0 && 's')+'</div>'+
          '<div class="subscription-content"><div class="pr-title">'+product_title+'</div><div class="subscription">'+subscription.quantity+' @ '+Shopify.formatMoney(Number(subscription.price) * 100, this.moneyFormat)+'</div><div class="subscription-actions show-desktop"><a href="javascript:void(0);" class="text-underline js-edit-subscription">Edit</a></div></div>'+
          '<div class="subscription-date">Next order on <span class="label-next-charge">'+next_charge_on+'</span></div>'+
          '<div class="show-mobile mt__20"><a href="javascript:void(0);" class="text-underline js-edit-subscription">Edit</a></div>';
        $subscriptionInformation.html($subscriptionInformationContent);
        $subscriptionInformation.on('click', '.js-edit-subscription', function() {
          $subscriptionInformation.parents('.recharge-subscription').toggleClass('open');
        });

        // Subscription Form
        let $subscriptionFormNextCharge = $('<div>', { class: 'subscription-next-charge rc-form-block' });
        let $nextChargeLabel = $('<div>', { class: 'rc-form-label', html: 'Next charge <span class="label-next-charge">' + next_charge_on + '</span>' });
        let $nextChargeToggle = $('<a>', { class: 'rc-toggler-button', href: 'javascript:void(0);', html: 'Change next charge date' });
        let $nextChargeContent = $('<div>', { class: 'rc-form-content hide' });
        let $nextChargeInput = $('<input>', { class: 'rc-form-input', type: 'date', value: next_charge_on_date });
        let $nextChargeSave = $('<div class="rc-form-actions"><a href="javascript:void(0);" class="rc-form-button btn js-save-btn">Save</a></div>');

        $subscriptionFormNextCharge.on('click', '.js-save-btn', this.onChangeSchedule.bind(this, subscription));

        $nextChargeContent.append($nextChargeInput);
        $nextChargeContent.append($nextChargeSave);

        $subscriptionFormNextCharge.append($nextChargeLabel);
        $subscriptionFormNextCharge.append($nextChargeToggle);
        $subscriptionFormNextCharge.append($nextChargeContent);
        
        $subscriptionForm.append($subscriptionFormNextCharge);

        // Append to table
        $subscriptions.append($rechargeSubscription);
      }
    }
    else {
      $subscriptions.html('<div class="no-results">You don&#39;t have any subscriptions</div>');
    }
  },

  onChangeSchedule: function(subscription, e) {
    let self = this;
    let $content = $(e.target).parents('.rc-form-content');
    let $input = $content.find('.rc-form-input');
    this.callAPI('POST', 'recharge_set_next_charge.php', { subscription_id: subscription.id, date: $input.val() }, function(res) {
      if (res.error) {
        alert(res.error);
      }
      else {
        let next_charge_on = moment($input.val()).format('MMMM DD, YYYY');
        $('.label-next-charge').html(next_charge_on);
        $content.addClass('hide');
      }
    });
  },

  callAPI: function(method, url, params, callback) {
    $.ajax({
      method: method,
      url: this.serverUrl+'/'+url,
      data: params,
      dataType: 'json',
      success: function(res) {
        callback(res);
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(textStatus);
      }
    });
  }
}

/*============================================================================
  Custom select
==============================================================================*/
theme.customSelect = {
  init: function($selector) {
    $selector.each(function() {
      let $this = $(this);
      let $select = $this.find('select');
      let $el_select = $select[0];
      let $selected = $('<div>', {class: 'select-selected'});
      $selected.html($el_select.options[$el_select.selectedIndex].innerHTML);
      $this.append($selected);

      let $items = $('<div>', {class: 'select-items select-hide'});
      for (let j = 0; j < $el_select.length; j++) {
        var item;
        if (j == 0) {
          $item = $('<div>', {class: 'select-item same-as-selected'});
        }
        else {
          $item = $('<div>', {class: 'select-item'});
        }
        $item.html($el_select.options[j].innerHTML);
        $items.append($item);

        $item.on('click', function(e) {
          for (let i = 0; i < $el_select.length; i++) {
            if ($el_select[i].innerHTML == $(this).html()) {
              $el_select.selectedIndex = i;
              $selected.html($(this).html());
              $this.find('.select-item').removeClass('same-as-selected');
              $(this).addClass('same-as-selected');
              $items.addClass('select-hide');
            }
          }
        });
      }

      $this.append($items);

      $selected.on('click', function() {
        $items.toggleClass('select-hide');
      });
    });
  }
}

function getQueryParams(e){var r=e.split("?"),t="";if(2==r.length&&(t=r[1],t=t.split("&")),""==t)return{};for(var n={},i=0;i<t.length;++i){var a=t[i].split("=");2==a.length&&(n[a[0]]=decodeURIComponent(a[1].replace(/\+/g," ")))}return n}

const AGE_OPTIONS = {
  'age1': '18-24',
  'age2': '25-34',
  'age3': '35-44',
  'age4': '44+'
}

/*============================================================================
  Ambassador
==============================================================================*/
theme.ambassador = {
  init: function() {
    this.moneyFormat = '${'+'{amount}}';
    this.serverUrl = AMBASSADOR_APP + '/api/frontend';

    if ($('.ambassador-list-wrapper').length > 0) {
      let $sidebar = $('.ambassador-sidebar');
      $sidebar.on('click', '.sidebar-item > a', this.toggleSidebarDropdown.bind(this));
      $sidebar.on('click', '.dropdown-menu-item', this.onFilterChange.bind(this));
      $sidebar.on('click', '.js-toggle-sidebar', this.onToggleSidebar.bind(this));
      $sidebar.on('click', '.js-clear-filter', this.onClearFilter.bind(this));

      this.filterData = {};
      this.getFilteredData();
    }
    else {
      this.isPreview = false;
      this.getAmbassadorBySlug();
    }
  },
  callAPI: function(method, url, params, callback) {
    $.ajax({
      method: method,
      url: this.serverUrl+'/'+url,
      data: params,
      dataType: 'json',
      success: function(res) {
        callback(res);
      },
      error: function(XMLHttpRequest, textStatus) {
        callback();
        console.log(textStatus);
      }
    });
  },
  getAmbassadorBySlug: function() {
    let href = location.pathname;
    let lastChar = href.substr(href.length - 1);
    if (lastChar == '/') {
      href = href.substr(0, href.length - 1);
    }
    let slug = href.substring(href.lastIndexOf('/') + 1);
    let params = getQueryParams(location.search);
    if (params.preview && params.preview == 'true') {
      this.isPreview = true;
    }

    let self = this;
    this.callAPI('POST', 'get_customer_by_slug', { slug: slug, isPreview: this.isPreview }, function(data) {
      self.updateDetailView(data || {});
    });
  },

  // Detail
  updateDetailView: function(ambassador) {
    let self = this;

    $('#preloader').addClass('hidden');

    if (ambassador.id) {
      $('.ambassador-404').addClass('hidden');
      $('.ambassador-detail-wrapper').removeClass('hidden');

      if (ambassador.avatar) {
        let avatar = ambassador.avatar.replace("//drive.google.com/open", "//drive.google.com/uc");
        $('.js-avatar').attr('src', avatar);
      }
      $('.js-instagram').html('@' + ambassador.instagram_handle);
      $('.js-instagram-url').attr('href', 'https://instagram.com/' + ambassador.instagram_handle);
      $('.js-introduction').html(ambassador.introduction);
      $('.js-age').html(AGE_OPTIONS[ambassador.age_range]);
      $('.js-location').html(ambassador.location);
      $('.js-skin-type').html(ambassador.skin_type);
      let skin_concerns_html = "";
      ambassador.skin_concerns.forEach(function(skin_concern) {
        skin_concerns_html += 
          '<li>'+
            '<span title="'+skin_concern+'" class="hidden icon-'+replaceString(skin_concern, '_', '-')+'"></span>'+
            '<span class="skin-name">'+replaceString(skin_concern, '_', ' ')+'</span>'+
          '</li>';
      });
      $('.js-skin-concern').html(skin_concerns_html); 
      // $('.js-values').html();
      $('.js-fun-fact').html(ambassador.fun_fact);
      $('.js-breakouts').html(ambassador.breakouts);
      $('.js-skincare-regimen').html(ambassador.skincare_regimen);
    }
    else {
      $('.ambassador-404').removeClass('hidden');
      $('.ambassador-detail-wrapper').addClass('hidden');
    }

    let galleries_html = "";
    ambassador.attaches.forEach(function(attach, index) {
      let _attach = attach.replace("//drive.google.com/open", "//drive.google.com/uc");
      galleries_html += 
        '<a class="gallery" href="'+_attach+'" data-index="'+index+'" rel="gallery">'+
          '<img class="owl-lazy" data-src="'+_attach+'" />'
        '</a>';
    });
    $('.ambassador-galleries').html(galleries_html);
    $('.ambassador-galleries').owlCarousel({
      margin: 10,
      navText: ['<i class="fa fa-2x fa-angle-left"></i>', '<i class="fa fa-2x fa-angle-right"></i>'],
      lazyLoad : true,
      slideSpeed : 700,
      paginationSpeed : 700,
      rewindSpeed : 700,
      responsive: {
        0: {
          items: 2,
          dots: false,
          nav: true
        },
        770: {
          items: 2,
          dots: false,
          nav: true
        },
        1200: {
          items: 4,
          dots: false,
          nav: true
        }
      }
    });

    $('.ambassador-galleries .owl-item a').fancybox();

    let products_html = "";
    ambassador.products.forEach(function(product) {
      products_html += self.buildProductItem(product);
    });
    $('.ambassador-product-list').html(products_html);
  },

  buildProductItem: function(product) {
    let productView = '';
    let available = false;
    let isSale = false;
    let priceVaries = false;
    let price = Number(product.variants[0].price);
    let compare_at_price = 0;
    let compare_at_price_max = 0;
    let tagline = '';
    let currentVariant = product.variants[0];

    if (product.metafields && product.metafields.length > 0) {
      let tagline_metafield = product.metafields.find(function(e) { return e.namespace == 'c_f' && e.key == 'tagline' });
      if (tagline_metafield) {
        tagline = tagline_metafield.value;
      }
    }

    product.variants.forEach(function(v) {
      if (v.inventory_quantity > 0) { available = true; }
      if (v.compare_at_price && Number(v.compare_at_price) && compare_at_price == 0) {
        compare_at_price = Number(v.compare_at_price);
      }
      if (v.compare_at_price && Number(v.compare_at_price) && compare_at_price > 0) {
        if (Number(v.compare_at_price) < compare_at_price) {
          compare_at_price = Number(v.compare_at_price);
        }
      }
      if (v.compare_at_price && Number(v.compare_at_price) > compare_at_price_max) { compare_at_price_max = Number(v.compare_at_price); }
      if (Number(v.price) != price) { priceVaries = true; }
      if (Number(v.price) < price) { price = Number(v.price); };
    });
    if (compare_at_price_max > price) { isSale = true; }

    productView += '<div class="grid__item large--one-quarter medium--one-half small--one-half wow fadeInUp">';

      productView += '<div class="grid-view-item" data-product-id="'+product.id+'">';

        productView += '<a href="/products/'+product.handle+'" title="'+product.title+'">';

          productView += '<div class="grid-view-item-image">';

          if (product.images.length > 1) {
            productView += '<div class="reveal">';
          }
              productView += '<div class="grid__image grid__image__match">';

              if (compare_at_price_max > price && available) {
                productView += '<div class="sale-badge">On Sale</div>';
              }

              if (!available) {
                productView += '<div class="sold-out-badge">Out of Stock</div>';
              }

              productView += this.getImageView(product.image);

                productView += '<div class="hidden">';
                if (product.images.length > 1) {
                  productView += this.getImageView(product.images[1]);
                }
                productView += '</div>';
              
              productView += '</div>';

          if (product.images.length > 1) {
            productView += '</div>';
          }

          productView += '</div>';

        productView += '</a>';

        productView += '<div class="grid-view-item--desc-wrapper">';

          productView += '<div class="product-grid--title">'+product.title+'</div>';

          if (tagline) {
          productView += '<div class="product-grid--subtitle">'+tagline+'</div>';
          }

          productView += this.getPriceView(isSale, priceVaries, price, compare_at_price);

          productView += this.getTagsView(product.tags);

         productView += '<div class="rating_summary" data-bv-show="rating_summary" data-bv-product-id="'+product.id+'"></div>';

        productView += '</div>';

        productView += this.buildATCForm(currentVariant);

      productView += '</div>';

    productView += '</div>';

    return productView;
  },

  buildATCForm: function(variant) {
    let view = '';

    if (variant.inventory_quantity > 0) {

      view += '<form action="/cart/add">';

      view += '<input type="hidden" name="id" value="'+variant.id+'">';
      view += '<input type="hidden" name="quantity" value="1">';
      view += '<button type="submit" class="btn add-to-cart-button">Add to Bag</button>';
    
      view += '</form>';
    }
    else {
      view += '<button type="submit" name="add" id="AddToCart" class="btn add-to-cart-button disabled" disabled=""><span id="AddToCartText">Out of Stock</span></button>';
    }

    return view;
  },

  getTagsView: function(tags) {
    let view = '<p class="tags-list">';
    let tagList = tags.split(', ');

    if (tags.includes('All Skin Types')) {
      view +=
        '<a href="/collections/all-skin-types">'+
          '<span title="All Skin Types" class="icon-all-skin-types"></span>'+
        '</a>';
    }
    else {
      for (var i = 0; i < tagList.length; i++) {
        let tag = tagList[i];
        if (tag.includes('Aging Skin') || tag.includes('Problem Skin') || tag.includes('Dullness') || tag.includes('Dryness')) {
          view +=
            '<a href="/collections/'+replaceString(tag.toLowerCase(), ' ', '-')+'">'+
              '<span title="'+tag+'" class="icon-'+replaceString(tag.toLowerCase(), ' ', '-')+'"></span>'+
            '</a>';
        }
      }
    }

    view += '</p>';

    return view;
  },

  getPriceView: function(isSale, priceVaries, price, compare_at_price) {
    let view = '<p class="product-grid--price">';

    if (isSale) {
      if (priceVaries) {
        view += '<strong>On Sale</strong> from '+Shopify.formatMoney(price * 100, this.moneyFormat);
      }
      else {
        view += '<span class="product-grid--compare-price"><span class="money">'+Shopify.formatMoney(compare_at_price * 100, this.moneyFormat)+'</span></span><span class="money">'+Shopify.formatMoney(price * 100, this.moneyFormat)+'</span>';
      }
    }
    else {
      if (priceVaries) {
        view += '<span class="product-grid--from-wrapper">from</span> <span class="money">'+Shopify.formatMoney(price * 100, this.moneyFormat)+'</span>';
      }
      else {
        view += '<span class="money">'+Shopify.formatMoney(price * 100, this.moneyFormat)+'</span>';
      }
    }

    view += '</p>';

    return view;
  },

  getImageView: function(image) {
    let view = '';

    view +=
      '<noscript>'+
        '<img '+
          'class=""'+
          'src="'+image.src+'"'+
          'data-sizes="auto"'+
          'alt="'+image.alt+'"'+
          'style="max-width: '+image.width+'px"'+
        '/>'+
      '</noscript>';

    let defaultUrl = image.src.replace(/(\.[^.]*)$/, "_150x$1").replace('http:', '');
    let responsiveUrl = image.src.replace(/(\.[^.]*)$/, "_1000x$1").replace('http:', '');
    let aspectRatio = image.width / image.height;

    view +=
      '<img '+
        'class="lazyload"'+
        'src="'+defaultUrl+'"'+
        'data-src="'+responsiveUrl+'"'+
        'data-sizes="auto"'+
        'data-aspectratio="'+aspectRatio+'"'+
        'alt="'+image.alt+'"'+
      '/>';

    return view;
  },

  // List
  getFilteredData: function() {
    let self = this;
    this.callAPI('POST', 'get_filtered_data', this.filterData, function(data) {
      self.updateListView(data || []);
    });
  },
  onFilterChange: function(e) {
    let $this = $(e.target);
    let $dropdown = $this.parent();
    let $sidebarItem = $this.parents('.sidebar-item');
    let $key = $sidebarItem.data('key');
    let $type = $sidebarItem.data('type');
    let $value = $this.data('value');

    if ($this.hasClass('active')) {
      $this.removeClass('active');
    }
    else {
      $dropdown.find('.dropdown-menu-item').removeClass('active');
      $this.addClass('active');
    }
    
    $sidebarItem.removeClass('open');

    if ($dropdown.find('.active').length === 0) {
      delete this.filterData[$key];
    }
    else {
      if ($type == 'array') {
        this.filterData[$key] = [$value];
      }
      else {
        this.filterData[$key] = $value;
      }
    }

    this.getFilteredData();
  },
  onClearFilter: function() {
    this.filterData = {};
    this.getFilteredData();
  },
  updateListView: function(ambassadors) {
    if (ambassadors.length == 0) {
      $('.ambassador-list').addClass('hidden');
      $('.ambassador-empty').removeClass('hidden');
      return;
    }

    $('.ambassador-list').empty();
    $('.ambassador-list').removeClass('hidden');
    $('.ambassador-empty').addClass('hidden');

    ambassadors.forEach(function(ambassador) {
      let ambassadorView = $('.ambassador-item.clone').clone();
      ambassadorView.removeClass('clone');

      if (ambassador.avatar) {
        let avatar = ambassador.avatar.replace("//drive.google.com/open", "//drive.google.com/uc");
        ambassadorView.find('.js-avatar').css('backgroundImage', 'url('+avatar+')');
      }

      if (ambassador.tracking_url && ambassador.tracking_url != "") {
        ambassadorView.find('.js-detail-page').attr('href', ambassador.tracking_url+'?url=https%3A%2F%2Fversedskin.com%2Fpages%2Fambassador-list%2F'+ambassador.slug);
      }
      else {
        ambassadorView.find('.js-detail-page').attr('href', '/pages/ambassador-list/'+ambassador.slug);
      }

      ambassadorView.find('.ambassador-instagram span').html('@'+ambassador.instagram_handle);
      let skin_concerns_html = "";
      ambassador.skin_concerns.forEach(function(skin_concern) {
        skin_concerns_html += 
          '<li>'+
            '<span title="'+skin_concern+'" class="hidden icon-'+replaceString(skin_concern, '_', '-')+'"></span>'+
            '<span class="skin-name">'+replaceString(skin_concern, '_', ' ')+'</span>'+
          '</li>';
      });
      ambassadorView.find('.ambassador-skin-concerns ul').html(skin_concerns_html); 
      ambassadorView.find('.ambassador-skin-type span').html(ambassador.skin_type);
      $('.ambassador-list').append(ambassadorView);
    });
  },
  toggleSidebarDropdown: function(e) {
    let $this = $(e.target);
    let $sidebar = $('.ambassador-sidebar');
    let $parent = $this.parent();

    $sidebar.find('.sidebar-item').each(function() {
      if (this != $parent[0]) {
        $(this).removeClass('open');
      }
      else {
        $parent.toggleClass('open');
      }
    });
  },
  onToggleSidebar: function(e) {
    $('.ambassador-sidebar').toggleClass('open');
  }
}

/*============================================================================
  Cart Page
==============================================================================*/
theme.cartPage = {
  init: function() {
    this.selectors = {
      removeItem: '.cart__remove',
      cartForm: 'form[action^="/cart"]'
    }

    $(document).on('submit', this.selectors.cartForm, this.handleSubmit.bind(this));
    $(document).on('click', this.selectors.removeItem, this.handleRemoveItem.bind(this));
  },
  handleSubmit: function(e) {
    var normalItems = $('.cart-table tbody .cart__row:not(.sample__item)');
    var hasSampleItems = $('.cart-table tbody .sample__item').length > 0;
    var hasAllZeroItems = true;
    normalItems.each(function(e) {
      var $this = $(this);
      var quantity = Number($this.find('.quantity').val());
      if (quantity != 0) {
        hasAllZeroItems = false;
      }
    });

    if (hasAllZeroItems && hasSampleItems) {
      e.preventDefault();
      ShopifyAPI.clearCart();
    }
  },
  handleRemoveItem: function(e) {
    var $this = $(e.target);
    var cartItem = $this.parents('.cart__row');
    var itemId = cartItem.data('id');
    if (!cartItem.hasClass('sample__item')) {
      var hasOneItemOnly = $('.cart-table tbody .cart__row:not(.sample__item)').length == 1;
      var hasSampleItems = $('.cart-table tbody .sample__item').length > 0;
      if (hasOneItemOnly && hasSampleItems) {
        e.preventDefault();
        ShopifyAPI.clearCart();
      }
    }
  }
}

theme.exitSkinModal = {
  init: function() {
    this.selectors = {
      desktopModal: '._desktop-exit-modal',
      mobileModal: '._mobile-exit-modal',
      closeDesktopModal: '._desktop-exit-modal .exit-modal-close',
      closeMobileModal: '._mobile-exit-modal .exit-modal-close',
    }

    this.initModal();

    $(document).on('click', this.selectors.closeDesktopModal, this.onCloseDesktopModal.bind(this))
    $(document).on('click', this.selectors.closeMobileModal, this.onCloseMobileModal.bind(this))
  },
  initModal: function() {
    var shown = this.getCookie('_exitIntent_shown');
    var mobileShown = this.getCookie('_mobileExitIntent_shown');
    var $desktopModal = $(this.selectors.desktopModal);
    var $mobileModal = $(this.selectors.mobileModal);
    var self = this;

    this.subscriberPopupShown(function() {
      var width = $(window).width();
      if (width > 768) {
        if (!shown) {
          setTimeout(function() {
            $desktopModal.addClass('active');
            self.setCookie('_exitIntent_shown', true, 1);
          }, 1000);
        }
      }
      else {
        if (!mobileShown && $mobileModal.length > 0) {
          self.initMobileModal();
        }
      }
    })
  },
  initMobileModal: function() {
    var $mobileModal = $(this.selectors.mobileModal);
    var scrollPoint = document.body.scrollHeight - 432;
    var self = this;

    /**
     * The ExitIntentMobile class above refers to an internally developed module that detects
     * a mobile user's intent to exit when they scroll up after a certain distance (`scrollPoint`)
     * has been scrolled.
     *
     * The below snippet shows how this is achieved.
     */

    let scrollHandler = function () {
      const scrollTop = window.pageYOffset || 
          (document.documentElement.clientHeight ? document.documentElement.scrollTop : document.body.scrollTop);

      // watch for the scroll point to be above the bottom of the window
      if (!this.scrollPointInView) {
        var scrollBottom = scrollTop + (document.documentElement.clientHeight || window.innerHeight);

        if (scrollPoint <= scrollBottom) {
          this.scrollPointInView = true;
        }
      } else {
        // user has scrolled down far enough
        // watch for them to scroll back up instead
        if (scrollTop < this.lastScrollTop - 10) {
          $mobileModal.addClass('active');
          self.setCookie('_mobileExitIntent_shown', true, 1);
          document.removeEventListener("scroll", scrollHandler);
        }
        this.lastScrollTop = scrollTop;
      }
    };

    scrollHandler = scrollHandler.bind(this);
    document.addEventListener("scroll", scrollHandler, false);
    // $mobileModal.addClass('active');
  },
  getCookie: function(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for(var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      
      /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
      if(name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
      }
    }
    
    // Return null if not found
    return null;
  },
  setCookie: function(name, value, daysToLive) {
    // Encode value in order to escape semicolons, commas, and whitespace
    var cookie = name + "=" + encodeURIComponent(value);
    
    if(typeof daysToLive === "number") {
      /* Sets the max-age attribute so that the cookie expires
      after the specified number of days */
      cookie += "; max-age=" + (daysToLive*24*60*60);
      
      document.cookie = cookie;
    }
  },
  subscriberPopupShown: function(callback) {
    var interval = setInterval(function() {
      if (document.cookie.indexOf('ltkpopup-suppression') > -1 && !document.querySelector('#ltkpopup-container')) {
        clearInterval(interval);
        callback();
      }
    }, 1000);
  },
  onCloseDesktopModal: function(e) {
    var $desktopModal = $(this.selectors.desktopModal);
    $desktopModal.removeClass('active');
  },
  onCloseMobileModal: function(e) {
    var $mobileModal = $(this.selectors.mobileModal);
    $mobileModal.removeClass('active');
  }
}

theme.pageQuizKitApp = {
  init: function () {
    this.checkUrlParams();
    this.changeVariant();
    this.slideshow();
    this.appendProducts();
    this.productsAddToCart();
    this.productsSelectAll();
    this.changeAsideTotalPrices();
    this.asideToggle();
    this.initClickByDefaultChecked();
  },

  checkUrlParams: function () {
    const searchParams = (new URL(document.location)).searchParams;
    const name = searchParams.get('name');
    const nameSelector = '[data-dynamic-name]';
    const sectionVisibleId = searchParams.get('section').trim();

    if (name) $(nameSelector).html(`${name}'s `).slideDown();

    $(`[data-search-param]:not([data-search-param="${sectionVisibleId}"])`).hide();
    localStorage.setItem('quizResultUrl', window.location.href);
  },

  changeVariant: function () {
    const _self = this;

    $('.qkr-product-item select').on('change', function() {
      const $this = $(this);
      const value = $this.val();
      const $product = $this.parents('.qkr-product-item');
      let $price = $this.find(`option[value=${value}]`).attr('data-variant-price');
      $price = Shopify.formatMoney($price, window.default_currency_format);
      const $itemPriceText = $product.find('[data-item-price]');
      const $btnAddToCart = $('.qkr-aside-add-to-cart');
      const $asideProductsInput = $('.qkr-aside-product-input-box input');

      _self.arrProductsInputValue = $.map($asideProductsInput, function(el) {
        return $(el).prop('checked');
      });

      $itemPriceText.text($price);
      $btnAddToCart.prop('disabled', true);
      _self.appendProducts();
    });
  },

  slideshow: function () {
    const $slideshow = $('.qkr-products-grid--slideshow');

    $slideshow.owlCarousel({
      pagination: true,
      navigation: true,
      margin: 0,
      dots: false,
      nav: true,
      navText: ['<i class="fa fa-2x fa-angle-left"></i>', '<i class="fa fa-2x fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 2,
          margin: 10
        },
        991: {
          items: 3
        }
      }
    });
  },

  appendProducts: function () {
    const $form = $('.qkr-product-item-form:visible');
    const _self = this;

    if (!$form.length) {return false}

    const productsHtml = jQuery.map( $form, function(el) {
      return _self.createProduct(el);
    });

    $('.qkr-aside-products').html(productsHtml);

    $('.qkr-aside-product-input-box input').each(function (index) {
      const inputCheckedValue = _self.arrProductsInputValue ? _self.arrProductsInputValue[index] : false;
      if (inputCheckedValue) {
        $(`label.qkr-aside-product[for="${$(this).attr('id')}"]`).trigger('click');
      }
    });
  },

  createProduct: function (el) {
    const $el = $(el);
    const customId = $el.attr('data-custom-id');
    const title = $el.attr('data-product-title');
    const variantId = $el.find('[name="id"]').val();
    const variantPrice =
      $el.find('input[name="id"]').length
        ? $el.find('input[name="id"]').attr('data-variant-price')
        : $el.find(`option[value=${variantId}]`).attr('data-variant-price');
    const variantPriceText =
      $el.find('input[name="id"]').length
        ? $el.find('input[name="id"]').attr('data-variant-price-text')
        : $el.find(`option[value=${variantId}]`).attr('data-variant-price-text');

    const product =
      `<label class="qkr-aside-product" for="${customId}">
        <div class="qkr-aside-product-input-box">
          <input type="checkbox" id="${customId}" name="id" value="${variantId}" data-variant-price="${variantPrice}">
          <span>[<span class="qkr-aside-product-input-checkmark">X</span>]</span>
        </div>
        <div>
          <h4>${title}</h4>
          <p>${variantPriceText}</p>
        </div>
      </label>`

    return product;
  },

  changeAsideTotalPrices: function () {
    $(document).on('change', '.qkr-aside-product input', function () {
      const $inputChecked = $('.qkr-aside-product input:checked');
      const $separatorPrice = $('.qkr-aside-price-separator');
      const $totalPrice = $('.qkr-aside-price');
      let totalPriceValue = 0;
      const $discountPrice = $('.qkr-aside-price-discount');
      const $btnAddToCart = $('.qkr-aside-add-to-cart');

      if ($inputChecked) {
        $inputChecked.map(function () {
          totalPriceValue = totalPriceValue + parseInt($(this).attr('data-variant-price'), 10);
          return totalPriceValue;
        });
      } else {
        totalPriceValue = 0;
      }

      const totalPriceValueFormat = Shopify.formatMoney(totalPriceValue, window.default_currency_format);

      if ($inputChecked.length > 2) {
        let discountPriceValue = totalPriceValue - ((10 / 100) * totalPriceValue);
        discountPriceValue = Shopify.formatMoney(discountPriceValue, window.default_currency_format);
        $separatorPrice.fadeIn();
        $discountPrice.text(totalPriceValueFormat).fadeIn();
        $totalPrice.text(discountPriceValue);
      } else {
        $separatorPrice.hide();
        $discountPrice.hide();
        $totalPrice.text(totalPriceValueFormat);
      }

      if ($inputChecked.length) {
        $btnAddToCart.prop('disabled', false);
      } else $btnAddToCart.prop('disabled', true);
    })
  },

  initClickByDefaultChecked: function () {
    const $form = $('.qkr-product-item-form:visible');

    jQuery.each( $form, function(index, el) {
      const $el = $(el);
      const checkedByDefault = $el.attr('data-default-sidebar-checked') === 'true';
      const id = $el.attr('data-custom-id');

      if (checkedByDefault) {
        $(`label.qkr-aside-product[for="${id}"]`).trigger('click');
      }
    });
  },

  productsSelectAll: function () {
    $(document).on('click', '.qkr-aside-select-all', function (evt) {
      evt.preventDefault()

      const $input = $('.qkr-aside-product input');
      if (!$input.length) {return false}

      $.each($input, function(index, el) {
        $(el).prop('checked', true);
      });

      $input.trigger('change');
    });
  },

  productsAddToCart: function () {
    $(document).on('click', '.qkr-aside-add-to-cart:not([disabled])', function (evt) {
      evt.preventDefault()

      const $inputChecked = $('.qkr-aside-product input:checked');
      if (!$inputChecked.length) {return false}

      const data = $.map( $inputChecked, function( value ) {
        return {
          id: value.value,
          quantity: 1,
          properties: {
            'quiz-result': 'product',
            '_quiz_kit_id': '2913',
            'og_subscription': 'false'
          }
        };
      });

      var $body = $(document.body),
        params = {
          type: 'POST',
          url: '/cart/add.js',
          data: {items: data},
          dataType: 'json',
          error: function(XMLHttpRequest, textStatus) {
            console.log('error');
            if ((typeof errorCallback) === 'function') {
              errorCallback(XMLHttpRequest, textStatus);
            }
            else {
              ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
            $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
          },
          complete: function(jqxhr, text) {
            $(document).find('[aria-controls="CartDrawer"]').trigger('click');
          }
        };

      $.ajax(params);
    });
  },

  asideToggle: function () {
    $(document).on('click', '.quiz-kit-result-aside--closed .qkr-aside-total', function () {
      $('.quiz-kit-result-aside--closed').removeClass('quiz-kit-result-aside--closed');
    });

    $('.qkr-aside--close').on('click', function () {
      $('.quiz-kit-result-aside').addClass('quiz-kit-result-aside--closed');
    });
  }
}

theme.submitBvReviewsYotpoAtions = {
  init: function () {
    $(document).on('click', '.bv-form-actions-submit', function () {
      const emailValue = $('input.bv-email[type="email"]').val();
      const ratingValue = $('.bv-submission-star-rating-on').length;
      const actionName = $('[data-yotpo-action-name-review]').attr('data-yotpo-action-name-review');

      if ($('.bv-submission-section').find('.bv-error').length || !emailValue || !actionName) {
        return false;
      }

      const headers = {
        'Content-Type': 'application/json'
      }

      const body = {
        'type': 'CustomAction',
        'customer_email': emailValue,
        'action_name': actionName
      }

      const options = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
      }

      const url = 'https://api.versedskin.com/loyalty/actions';

      fetch(url, options)
        .then(res => res.json())
        .then(json => console.log(json))
        .catch(err => console.error('error:' + err));
    })
  }
}

/*============================================================================
  Init theme
==============================================================================*/
theme.init = function() {
  theme.samplingCheckout.init();
  theme.cartUpsellProducts.init();
  theme.cartPage.init();
  theme.bundleProductPage.init();
  theme.customSelect.init($('.custom-select'));
  theme.submitBvReviewsYotpoAtions.init();
  theme.indexPage.init();


  if ($('.template-cart').length > 0) {
    theme.cartPage.init();
  }

  if ($('.product-page').length > 0) {
    theme.productPage.init();
  }

  if ($('.contact-page').length > 0) {
    theme.contactPage.init();
  }

  if ($('.template-customers-account').length > 0) {
    theme.account.init();
    
  }

  if ($('.ambassador-page').length > 0) {
    theme.ambassador.init();
  }

  if ($('.template-collection').length > 0 || $('.template-product').length > 0) {
    
  }

  if ($('.quiz-kit-app-result-wrapper').length) {
    theme.pageQuizKitApp.init();
  }

  setTimeout(function() {
    // Fix Owl Carousel initially loading slides with wrong width
    $('.owl-carousel').trigger('refresh.owl.carousel');
  }, 600);

  const quizResultUrl = localStorage.getItem('quizResultUrl');

  if (quizResultUrl) {
    const btn = $('ul li a[href="/pages/skin-decoder"]');
    btn.text('My Skincare Routine');
    btn.attr('href', quizResultUrl);
  }

}

AOS.init();
$(theme.init);
